import { Button, FormControl, Grid, TextField } from '@mui/material'
import { DownloadCloud } from 'react-feather'

export const SlipSection = ({ useFetchInit, readOnlyMode }) => {

    const {
        Forms,
        Actions
    } = useFetchInit

    const { FormScreen } = Forms
    const { formState, onInputChange } = FormScreen

    const { handleClickDownloadImage } = Actions

    return (
        <>  
            <div className="pt-4"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="numero_comprobante"> * Número de boleta</label>
                        <TextField
                            id='numero_comprobante'
                            name='numero_comprobante'
                            value={ formState.numero_comprobante } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Ingrese número de boleta'
                            type='text'
                            variant={readOnlyMode? 'filled': 'outlined'}
                            hiddenLabel
                            InputProps={{
                                readOnly: readOnlyMode 
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="dowload-boleta">* Boleta de Deposito</label>
                        <Button
                            startIcon={<DownloadCloud/>}
                            color='success'
                            variant="contained"
                            onClick={
                                (event) => handleClickDownloadImage(
                                    formState.attachments[0].attachment_originalname,
                                    formState.attachments[0].attachment_path
                                )
                            }
                            sx={{textDecoration: 'none', paddingTop: 1}}
                        >Descargar</Button>
                    </FormControl>
                </Grid>
            </Grid>
        </>
    )
}
